import { gql } from "@apollo/client";

import { Campaign, CommunicationSources } from "Types/Campaign";

export const getCampaigns = gql`
    query ($queryParams: QueryParams!) {
        campaigns(queryParams: $queryParams) {
            id
            friendlyId
            name
            state
            messageType
            type
            description
            createdAt
            updatedAt
            createdBy
            updatedBy
        }
    }
`;

export const getCampaignsWithPreview = gql`
    query ($queryParams: QueryParams!) {
        campaigns(queryParams: $queryParams) {
            id
            friendlyId
            name
            state
            messageType
            type
            description
            createdAt
            updatedAt
            createdBy
            updatedBy
            smsCampaign {
                id
                content
                mediaURL
                fromNumber
            }
        }
    }
`;

export const getPaginatedCampaigns = gql`
    query GetPaginatedCampaigns($queryParams: QueryParams!) {
        getCampaigns(queryParams: $queryParams) {
            hasMore
            items {
                id
                friendlyId
                name
                state
                messageType
                type
                description
                tags {
                    id
                    name
                }
                phoneCallCampaign {
                    id
                    dialingModeDisplay
                    priority
                    priorityStrategy
                }
                createdAt
                updatedAt
                createdBy
                updatedBy
            }
        }
    }
`;

export const getCampaignAgents = gql`
    query ($queryParams: QueryParams!) {
        campaigns(queryParams: $queryParams) {
            createdBy
            updatedBy
        }
    }
`;

export const getCampaignsAgents = gql`
    query getCampaignsAgents {
        getCampaignsAgents {
            createdByNames
            updatedByNames
            hasNullCreators
            hasNullUpdaters
        }
    }
`;

export type CampaignByIdResponse = {
    campaignWithUnhiddenJourneys: Campaign;
};

export const getCampaignById = gql`
    query ($id: String!) {
        campaignWithUnhiddenJourneys(id: $id) {
            id
            friendlyId
            name
            description
            state
            messageType
            type
            tags {
                id
                name
            }
            conversionEvent
            bypassOptIn
            tasksBacklogLimit
            segments {
                id
                count
            }
            campaignsJourneys {
                journey {
                    id
                    friendlyId
                    name
                    state
                }
            }
            smsCampaign {
                id
                content
                mediaURL
                fromNumber
            }
            phoneCallCampaign {
                id
                nickname
                fromNumber
                dialingModeDisplay
                goal
                scriptUrl
                voicemailInstructions
                overrideFromNumber
                prerecordedVoiceMessage {
                    id
                    friendlyName
                }
                abandonedRecording {
                    id
                    friendlyName
                }
                greetingRecording {
                    id
                    friendlyName
                }
                defaultVoicemail
                eligibleOffer
                scriptUrl
                targetQueueSid
                maxParallelCalls
                predictiveCallAgentRatioCeiling
                priority
                priorityStrategy
                recordingType
                targetAbandonRate
                transferQueueSid
                transferRateCeiling
            }
        }
    }
`;

export type CommunicationSourcesResponse = {
    getCommunicationSources: CommunicationSources[];
};

export const getCommunicationSources = gql`
    query ($channel: String) {
        getCommunicationSources(channel: $channel) {
            internalDisplayName
            externalDisplayName
            source
        }
    }
`;

export const getRenderedSMSCampaignTemplate = gql`
    query ($renderedSMSTemplateInput: RenderedSMSTemplateInput!) {
        getRenderedSMSCampaignTemplate(renderedSMSTemplateInput: $renderedSMSTemplateInput) {
            smsContentTemplate
            renderedSMSContentTemplate
        }
    }
`;
